import {ComponentClassName} from "@dp-instant/ui";
import {gsap} from "gsap/gsap-core";
import {useLayoutEffect, useState} from "preact/hooks";

interface MultiplyArrow extends ComponentClassName {
    paused?: boolean;
    step?: number;
    onPause?(multiply?: any): void;
}
const HALF_PI = Math.PI / 2;
const ANGLE_MAX = (Math.PI / 180) * 73;
const Rx = 190,
    Ry = 160,
    offsetX = 118,
    offsetY = 200;

const multipliers = [2, 3, 4, 3, 2];
const thresholdPoints = [0.15, 0.35, 0.62, 0.82];
const getMultiplierByProgress = (progres = 0) => {
    let index = 0;
    if (progres > thresholdPoints[3]) {
        index = 4;
    } else if (progres > thresholdPoints[2] && progres <= thresholdPoints[3]) {
        index = 3;
    } else if (progres > thresholdPoints[1] && progres <= thresholdPoints[2]) {
        index = 2;
    } else if (progres > thresholdPoints[0] && progres <= thresholdPoints[1]) {
        index = 1;
    }
    return multipliers[index];
};

export const MultiplyArrow = ({className, paused = false, onPause}: MultiplyArrow) => {
    const [state, setState] = useState(() => ({
        paused,
        progress: 0
    }));
    const {progress} = state;
    useLayoutEffect(() => {
        if (paused) {
            if (onPause) {
                const mult = getMultiplierByProgress(progress);
                onPause(mult);
            }
        } else {
            const obj = {value: 0};
            gsap.fromTo(
                obj,
                {value: 0},
                {
                    value: 1,
                    repeat: Infinity,
                    yoyo: true,
                    ease: "linear",
                    onUpdate: () => setState(state => ({...state, progress: obj.value}))
                }
            );
            return () => gsap.killTweensOf(obj);
        }
    }, [paused]);

    const angle = ANGLE_MAX * (progress - 0.5) - HALF_PI;
    const x = offsetX + Rx * Math.cos(angle);
    const y = offsetY + Ry * Math.sin(angle);

    return (
        <div
            style={{
                transform: `translate(${x}px, ${y}px) rotate(${angle + HALF_PI}rad)`
            }}
            className="multiply-arrow"
        ></div>
    );
};
